module.exports = __webpack_public_path__ + "images/no-path.70032d4cf7fa41f6e8d41d174d6b46a6.png";